module.exports = __webpack_public_path__ + "img/haijunlan3.51dba142.png";